import {
    AfterViewInit,
    Component,
    Inject,
    Input,
    LOCALE_ID,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import { columnResize } from '../../shared/columnResize';
import { environment } from '../../../environments/environment';
import * as fromDataServices from '../../data-services';
import { BurdenModel } from '../../data-services/burden';
import * as fromShared from '../../shared';
import { IColumn, ResponseStatus, SelectItem } from '../../shared';
import { LoggingService } from '../../shared/services/logging';
import { ReplaySubject, combineLatest } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

@Component({
    selector: 'ef-burden-presenter',
    templateUrl: './burden-presenter.component.html',
    styleUrls: ['./burden-presenter.component.scss'],
    standalone: false
})
export class BurdenPresenter
    extends fromShared.EditGrid<fromDataServices.Burden.BurdenModel>
    implements OnInit, OnDestroy, AfterViewInit
{
    @Input() loading: boolean;
    @Input() cols: IColumn[] = [];
    @Input() colGroups: IColumn[] = [];
    @Input() contracts: SelectItem[];
    @Input() chargeNumbers: SelectItem[];
    @Input() contractTypes: SelectItem[];
    @Input() showDetails = false;

    clonedBurdens: BurdenModel[] = [];
    checkboxData: BurdenModel;
    loadingType: string;
    calcDesc: string;

    IsColumnFrozen = false;

    private LoadCloneSubject = new ReplaySubject<boolean>(1);
    private _loadclone: boolean;
    @Input() set loadClone(value: boolean) {
        this._loadclone = value;
        this.LoadCloneSubject.next(this._loadclone);
    }
    get loadClone(): boolean {
        return this._loadclone;
    }

    private BurdensSubject = new ReplaySubject<BurdenModel[]>(1);
    private _burdens: Array<BurdenModel>;
    @Input() set burdens(value: Array<BurdenModel>) {
        this._burdens = value;
        this.BurdensSubject.next(this._burdens);
    }
    get burdens(): Array<BurdenModel> {
        return this._burdens;
    }

    public dropdownItemHeight = environment.dropdownItemHeight;
    numCols = 9;
    frozenCols: any[] = [
        { field: 'Status', header: '' },
        { field: 'Contract', header: 'Contract' },
        { field: 'Charge Number', header: 'Charge Number' },
        { field: 'Contract Type', header: 'Contract Type' }
    ];
    elements: HTMLCollection;
    active = true;
    constructor(
        private log: LoggingService,
        @Inject(LOCALE_ID) private locale: string
    ) {
        super();
    }

    ngOnInit(): void {
        setTimeout(() => {
            this.elements = document.getElementsByClassName('p-header-cell');
        }, 0);

        combineLatest([this.BurdensSubject, this.LoadCloneSubject])
            .pipe(takeWhile(() => this.active))
            .subscribe(([burdens, clone]) => {
                if (burdens && burdens.length > 0) {
                    if (clone == true) {
                        this.clonedBurdens = this._burdens;
                        this.IsColumnFrozen = true;
                    } else {
                        if (this.checkboxData != null) {
                            const match = burdens.find(
                                x => x.CNListID == this.checkboxData.CNListID
                            );
                            const failed = burdens.some(
                                x => x.Status.StatusCode == 3
                            );
                            if (match && this.calcDesc) {
                                this.checkboxData[this.calcDesc] = {
                                    ...this.checkboxData[this.calcDesc],
                                    [this.loadingType]:
                                        match[this.calcDesc]?.[
                                            this.loadingType
                                        ]
                                };
                            }
                            this.checkboxData.Status = failed
                                ? {
                                      StatusCode: ResponseStatus.Error,
                                      Message: 'Update Failed'
                                  }
                                : {
                                      StatusCode: ResponseStatus.Success,
                                      Message: 'Success'
                                  };
                        }
                        this.IsColumnFrozen = true;
                    }
                } else {
                    this.clonedBurdens = [];
                    this.IsColumnFrozen = false;
                }
            });
    }
    ngAfterViewInit(): void {

    }
    ngOnDestroy() {
        this.active = false;
    }
    onExport($event: { data: any; field: string }) {
        return $event.data;
    }

    // formatColumn = (item: BurdenModel, col: IColumn) => {
    //     try {
    //         if (item && item[col.group]) {
    //             switch (col.field) {
    //                 default:
    //                     return item[col.group][col.field];
    //                     break;
    //             }
    //         }
    //         return '';
    //     } catch (e) {
    //         this.log.error(e, item, col);
    //     }
    // };
    checkboxChanged(e, data: BurdenModel, calcDesc, loadingType) {
        this.log.verbose({
            type: 'BurdenPresenter:checkboxChanged',
            e,
            data,
            calcDesc,
            loadingType
        });
        this.checkboxData = data;
        this.calcDesc = calcDesc;
        this.loadingType = loadingType;
        // data.Status = {
        //     StatusCode: ResponseStatus.Loading,
        //     Message: 'Saving'
        // };
        //// (data[calcDesc] as any).loading = true;
        this.SaveItem.next({
            id: data.id,
            CNlistid: data.CNListID,
            Calcdesc: calcDesc,
            Loadingtype: loadingType,
            LoadYesNo: e.currentTarget.checked
        } as any);
        // this.SettingChangedSubject.next({ value: $event.checked, data });
    }

    onColumnResize($event) {
        const table = document.querySelector('table');
        columnResize($event, 4, table);
    }
}
